import useCalls from './calls';

export const calls = useCalls();

export default { calls };
